module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadCrumbsItems,
      "divider": ">"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('client-quality-rating', {
    attrs: {
      "theme": "#36a2eb",
      "title": _vm.CLIENT_RATING.title,
      "headers": _vm.clientHeaders,
      "items": _vm.CLIENT_RATING.items,
      "filterCampaigns": _vm.filterCampaigns,
      "filterUsers": _vm.filterUsers,
      "filterUserLabel": "AM Filter"
    },
    on: {
      "searchfilter": _vm.clientSearch
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44950365"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AMDashboard/quality.vue
// module id = 2100
// module chunks = 0